export type Brand = {
  id: number;
  name: string;
  slug: string;
  logo: string | null;
};

export type BrandPatchInput = {
  id: string;
  name?: string;
  logo?: File;
};

export const partners = {
  default: 'default',
  bestdrive: 'bestdrive',
  tronderdekk: 'tronderdekk',
  carglass: 'carglass'
};

export type Partner = keyof typeof partners;
